module.exports = __webpack_public_path__ + "media/nl_nl_s1_Jasmijn.9511b723.mp3";